<template>
  <v-autocomplete 
    label=""
    :items="locations"
    item-text="name"
    item-value="id"
    return-object
    :value="selectedLocation"
    filled
    rounded
    dense
    hide-details
    :color="getContrast($vuetify.theme.themes.light.header) === 'black' || !getTwoColorContrast($vuetify.theme.themes.light.header, $vuetify.theme.themes.light.primary) ? undefined : 'accent'"
    :background-color="getContrast($vuetify.theme.themes.light.header) === 'black' ? 'accent' : undefined"
    @change="setSelectedLocation"
    :loading="loadingLocations"
    placeholder="Please Select"
    prepend-inner-icon="pin_drop"
  >
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'Locations',
  data () {
    return {}
  },
  mounted () {
    this.getLocations({
      organization_id: this.organizationId,
      commercial_client_id: this.commercialClientId
    })
      .then(() => {
        this.setSelectedLocation(this.locations[0])
      })
    this.getCommercialClient({
      organization_id: this.organizationId,
      commercial_client_id: this.commercialClientId
    })
  },
  beforeDestroy () {
  },
  methods: {
    ...mapActions(['getLocations', 'getCommercialClient']),
    ...mapMutations(['setSelectedLocation']),
  },
  computed: {
    ...mapGetters([
      'commercialClient',
      'locations',
      'loadingLocations',
      'organizationId',
      'commercialClientId',
      'selectedLocation',
      'getContrast',
      'getTwoColorContrast'
    ]),
  }
}
</script>
